export const ARTICLE_URL = '/articles';
export const TABLES_URL = '/tables';
export const NEWS_URL = '/news';
export const FIXTURES_URL = '/fixtures';
export const TOURNAMENTS_URL = '/tournaments';
